import { z } from 'zod';
import { JOB_STATUSES } from '../constants.js';
import { optionalTrimmed, uuidSchema } from './common.js';
export const jobListQuerySchema = z.object({
    status: z.enum(JOB_STATUSES).optional(),
    installerId: uuidSchema.optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    locationId: uuidSchema.optional(),
});
export const jobListItemSchema = z.object({
    id: uuidSchema,
    number: z.number(),
    status: z.enum(JOB_STATUSES),
    customerName: z.string(),
    vehicleLabel: z.string(),
    serviceSummary: z.string(),
    installerNames: z.array(z.string()),
    scheduledStart: z.string().nullable(),
    scheduledEnd: z.string().nullable(),
    totalCents: z.number().nullable(),
    depositCents: z.number().nullable(),
    balanceCents: z.number().nullable(),
    locationId: uuidSchema,
});
export const jobEventSchema = z.object({
    id: uuidSchema,
    type: z.string(),
    fromStatus: z.string().nullable(),
    toStatus: z.string().nullable(),
    message: z.string(),
    actorId: uuidSchema.nullable(),
    createdAt: z.string(),
});
export const jobPaymentSchema = z.object({
    id: uuidSchema,
    kind: z.string(),
    method: z.string(),
    amountCents: z.number(),
    status: z.string(),
    receivedAt: z.string(),
    notes: z.string(),
});
export const jobDetailSchema = z.object({
    id: uuidSchema,
    number: z.number(),
    status: z.enum(JOB_STATUSES),
    customerId: uuidSchema,
    customerName: z.string(),
    vehicleId: uuidSchema,
    vehicleLabel: z.string(),
    quoteId: uuidSchema,
    assignedInstallers: z.array(z.object({ id: uuidSchema, fullName: z.string() })),
    scheduledStart: z.string().nullable(),
    scheduledEnd: z.string().nullable(),
    notes: z.string(),
    // §34.3 shop bays + availability-first scheduling - surfaced so the client
    // scheduling flow knows the segment duration/cure tail/customer preference
    // without a second round trip.
    estimatedMinutes: z.number().int().nullable(),
    cureHoldMinutes: z.number().int().nullable(),
    preferredDate: z.string().nullable(),
    preferredTime: z.number().int().nullable(),
    lineItems: z.array(z.object({ serviceName: z.string(), coverageName: z.string(), materialBrand: z.string(), materialSeries: z.string() })),
    // money fields are omitted entirely (not nulled) in the installer DTO - see server-side stripping
    totalCents: z.number().optional(),
    depositCents: z.number().optional(),
    balanceCents: z.number().optional(),
    payments: z.array(jobPaymentSchema).optional(),
    completedAt: z.string().nullable(),
    createdAt: z.string(),
    locationId: uuidSchema,
});
export const updateJobSchema = z.object({
    notes: optionalTrimmed(2000),
    scheduledStart: z.string().datetime().nullable().optional(),
    scheduledEnd: z.string().datetime().nullable().optional(),
});
export const jobStatusUpdateSchema = z.object({ to: z.enum(JOB_STATUSES) });
export const assignJobSchema = z.object({ installerIds: z.array(uuidSchema) });
export const recordPaymentSchema = z.object({
    method: z.enum(['cash', 'etransfer', 'card', 'other']),
    amountCents: z.number().int().positive(),
    notes: optionalTrimmed(500),
});
export const calendarEventSchema = z.object({
    jobId: uuidSchema,
    number: z.number(),
    title: z.string(),
    status: z.enum(JOB_STATUSES),
    scheduledStart: z.string(),
    scheduledEnd: z.string().nullable(),
    installerNames: z.array(z.string()),
    customerName: z.string(),
    customerEmail: z.string().nullable(),
    customerPhone: z.string().nullable(),
});
//# sourceMappingURL=jobs.js.map